import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../../components/Common/DeleteModal";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import CustomTimezoneSelect from "../CustomTimezoneSelect";
import withAuth from "../withAuth";
import axios from "axios"; import { handleAuthError } from "../../utils";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  Input,
  FormFeedback,
  Badge,
} from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from '../../Network';
import PaginationControls from "../../components/Common/PaginationControls";
import ActionsDropdown from "../../components/Common/ActionsDropdown";
import ChildProgramsModal from "../../components/Common/ChildProgramsModal";
import { useConfirm } from "../../contexts/ConfirmContext";
import { isMarketerReadOnly } from "../../helpers/adminRole";

const ManageChild = () => {
  document.title = "Manage Child | RYD Admin";
  const { showConfirm } = useConfirm();
  const navigate = useNavigate();
  const readOnly = isMarketerReadOnly();

  const [users, setUsers] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [contact, setContact] = useState({});
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [actionLoadingId, setActionLoadingId] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 20,
    hasNextPage: false,
    hasPreviousPage: false
  });
  const [showAll, setShowAll] = useState(false);
  const [deactivatedFilter, setDeactivatedFilter] = useState("all");
  const [programFilter, setProgramFilter] = useState(0);

  // View all programs modal
  const [programsModal, setProgramsModal] = useState(false);
  const [programsChild, setProgramsChild] = useState(null);

  const openProgramsModal = (user) => {
    setProgramsChild(user);
    setProgramsModal(true);
  };

  useEffect(() => {
    // fetchParents();
    fetchChildren();
  }, [currentPage, pageSize, searchQuery, deactivatedFilter]);

  // const fetchParents = async () => {
  //   try {
  //     const response = await axios.get(`${baseUrl}/admin/parent/all`);
  //     setParentOptions(response.data.data);
  //   } catch (error) { handleAuthError(error)
  //     console.error(error);
  //   }
  // };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: contact.firstName || "",
      lastName: contact.lastName || "",
      age: contact.age || "",
      gender: contact.gender || "",
      parentId: contact.parentId || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter Child's First Name"),
      lastName: Yup.string().required("Please Enter Child's Last Name"),
      age: Yup.string().required("Please Enter Child's Age"),
      gender: Yup.string().required("Please Enter Child's Gender"),
      parentId: Yup.string().required("Please Select a Parent"),
    }),

    onSubmit: async (values) => {
      try {
        const newChild = {
          firstName: values.firstName,
          lastName: values.lastName,
          age: values.age,
          gender: values.gender,
          parentId: values.parentId,
        };


        let response;
        if (isEdit) {

          response = await axios.put(
            `${baseUrl}/admin/child/edit/${contact.id}`,
            newChild
          );
          toast.success("Child updated successfully");
        } else {
          response = await axios.post(
            `${baseUrl}/admin/child/create`,
            newChild
          );
          toast.success("Child created successfully");
        }

        toggle();
        await fetchChildren();
      } catch (error) { handleAuthError(error)
        console.error(error);
      }
    },
  });

  const fetchChildren = async () => {
    try {
      setLoading(true);
      const limit = showAll ? 10000 : pageSize;
      const params = {
        page: currentPage,
        limit: limit,
        ...(searchQuery && { search: searchQuery }),
        ...(deactivatedFilter && deactivatedFilter !== "all" ? { deactivated: deactivatedFilter } : {}),
      };
      const response = await axios.get(`${baseUrl}/admin/child/all`, { params });
      const responseData = response.data.data;
      const data = Array.isArray(responseData) ? responseData : (responseData?.data || []);
      const paginationData = responseData?.pagination || {
        currentPage: 1,
        totalPages: 1,
        totalItems: Array.isArray(data) ? data.length : 0,
        itemsPerPage: limit,
        hasNextPage: false,
        hasPreviousPage: false
      };
      setPagination(paginationData);
      setLoading(false);
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) { handleAuthError(error)
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    const list = users;
    if (programFilter === 1) {
      setUsersData(
        list.filter(
          (r) =>
            r?.programs?.filter((y) => y.isPaid === true && !y.isCompleted === false).length > 0
        )
      );
    } else if (programFilter === 2) {
      setUsersData(
        list.filter(
          (r) =>
            r?.programs?.filter((y) => y.isPaid === true && y.isCompleted === false).length > 0
        )
      );
    } else {
      setUsersData(list);
    }
  }, [users, programFilter]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (size) => {
    if (size === 'all') {
      setShowAll(true);
      setPageSize(10000);
    } else {
      setShowAll(false);
      setPageSize(parseInt(size));
      setCurrentPage(1);
    }
  };

  const goToNextPage = () => {
    if (pagination.hasNextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (pagination.hasPreviousPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const toggle = () => {
    setModal(!modal);
  };

  const handleUserClick = (userData) => {
    if (readOnly) return;
    setContact(userData);
    setIsEdit(true);
    toggle();
  };

  const onClickDelete = (userData) => {
    if (readOnly) return;
    setContact(userData);
    setDeleteModal(true);
  };

  const handleDeleteUser = async () => {
    try {
      await axios.delete(`${baseUrl}/admin/child/${contact.id}`);
      setDeleteModal(false);
      toast.success("Child deleted successfully");
      await fetchChildren();
    } catch (error) { handleAuthError(error)
      console.error(error);
      toast.error("Failed to delete child");
    }
  };


  const handleComplete = async (id) => {
    //check and push to server
    await axios.put(`${baseUrl}/admin/complete/child/programs/${id}`);
    toast.success("Programs completed successfully");
    // await fetchChildren()
  }

  const toggleChildDeactivation = (user, deactivate) => {
    showConfirm({
      title: deactivate ? "Deactivate child?" : "Activate child?",
      message: deactivate
        ? "The parent will no longer see this child on their dashboard. You can activate the child again later."
        : "The parent will see this child on their dashboard again.",
      variant: deactivate ? "warning" : "primary",
      confirmLabel: deactivate ? "Deactivate" : "Activate",
    }).then(async (ok) => {
      if (!ok) return;
      setActionLoadingId(user.id);
      try {
        await axios.put(`${baseUrl}/admin/child/deactivation/${user.id}`, {
          isDeactivatedByAdmin: !!deactivate,
        });
        toast.success(deactivate ? "Child deactivated" : "Child activated");
        await fetchChildren();
      } catch (error) {
        handleAuthError(error);
        toast.error("Failed to update child status");
      } finally {
        setActionLoadingId(null);
      }
    });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ChildProgramsModal
        isOpen={programsModal}
        toggle={() => setProgramsModal(!programsModal)}
        childId={programsChild?.id}
        childName={programsChild ? `${programsChild.firstName || ""} ${programsChild.lastName || ""}`.trim() : ""}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Manage Child" />
          {readOnly && (
            <Row className="mb-2">
              <Col>
                <div className="alert alert-secondary mb-3 py-2">
                  Read-only view — search and filters only; actions are disabled.
                </div>
              </Col>
            </Row>
          )}
          <Row className="align-items-center">
            <Col md={6}>
              <div className="mb-3">
                <h5 className="card-title">
                  Child List{" "}
                  <span className="text-muted fw-normal ms-2">
                    ({pagination.totalItems ?? users.length})
                  </span>
                </h5>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3 p-3 bg-light rounded filter-bar">
                <div style={{ width: 200 }}>
                  <select
                    className="form-control"
                    value={programFilter}
                    onChange={(e) => setProgramFilter(Number(e.target.value))}
                  >
                    <option value={0}>All Children</option>
                    <option value={1}>Active Program(s)</option>
                    <option value={2}>No Active Program(s)</option>
                  </select>
                </div>
                <div style={{ width: 200 }}>
                  <select
                    className="form-control"
                    value={deactivatedFilter}
                    onChange={(e) => {
                      setDeactivatedFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="all">Deactivated: All</option>
                    <option value="yes">Deactivated: Yes</option>
                    <option value="no">Deactivated: No</option>
                  </select>
                </div>
                <div>
                  <Input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
                <div className="d-flex gap-2">
                  {!readOnly && (
                  <>
                  <Link
                    to="/duplicatechild"
                    className="btn btn-warning"
                  >
                    <i className="mdi mdi-alert-circle me-1"></i> Duplicate
                  </Link>
                  <Link
                    to="/all-children-list"
                    className="btn btn-info"
                  >
                    <i className="mdi mdi-format-list-bulleted me-1"></i> All Children List
                  </Link>
                  </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="12">
              <Row>
                <Col xl="12">
                  {loading ? (
                    <div className="text-center mt-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : pagination.totalItems === 0 ? (
                    <div className="text-center mt-5">
                      <h3>No data available</h3>
                    </div>
                  ) : usersData.length === 0 ? (
                    <div className="text-center mt-5">
                      <h3>No rows match the program filter</h3>
                      <p className="text-muted">Try &quot;All Children&quot; or change page filters.</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                    <table className="table align-middle">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Parent Name</th>
                          <th>Phone</th>
                          <th>Current Cohort</th>
                          <th>Schedule conflict</th>
                          <th>Age</th>
                          <th>Gender</th>
                          <th>Privacy Mode</th>
                          <th>Deactivated</th>
                          {!readOnly && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {usersData.map((user, index) => {
                          const globalIndex = showAll 
                            ? index 
                            : (pagination.currentPage - 1) * pagination.itemsPerPage + index;
                          return (
                            <tr key={user.id || index} style={{
                              backgroundColor: (user?.parent?.privacyMode || user?.privacyMode) ? '#ffeff2' : '#fff',
                              border: user?.teacherScheduleConflict ? '2px solid #fd7e14' : undefined,
                            }}>
                              <td>{globalIndex + 1}</td>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user?.parent?.firstName} {user?.parent?.lastName}</td>
                            <td>{user?.parent?.phone}</td>
                            <td>{user?.currentCohortTitle || "No Cohort"}</td>
                            <td>{user?.teacherScheduleConflict ? (
                              <span className="blink text-warning"><Badge color="warning" className="text-dark">CONFLICT</Badge></span>
                            ) : "—"}</td>
                            <td>{user.age}</td>
                            <td>{user.gender}</td>
                            <td>{(user?.parent?.privacyMode || user?.privacyMode) ? "Private" : "Not Private"}</td>
                            <td>
                              <span
                                className={`badge ${user?.isDeactivatedByAdmin ? "bg-success" : "bg-danger"}`}
                              >
                                {user?.isDeactivatedByAdmin ? "Yes" : "No"}
                              </span>
                            </td>
                            {!readOnly && (
                            <td>
                              <ActionsDropdown
                                loading={actionLoadingId === user.id}
                                toggleTitle="Child actions"
                                items={[
                                  { label: "Edit", icon: "mdi-pencil", onClick: () => { handleUserClick(user); setIsEdit(true); }, variant: "success" },
                                  { label: "View all programs", icon: "mdi-eye-outline", onClick: () => openProgramsModal(user), variant: "info" },
                                  {
                                    label: "Duplicate names tool",
                                    icon: "mdi-account-multiple-outline",
                                    onClick: () => navigate("/duplicatechild"),
                                    variant: "warning",
                                  },
                                  ...(user?.isDeactivatedByAdmin
                                    ? [
                                        {
                                          label: "Activate",
                                          icon: "mdi-account-check",
                                          onClick: () => toggleChildDeactivation(user, false),
                                          variant: "success",
                                        },
                                      ]
                                    : [
                                        {
                                          label: "Deactivate",
                                          icon: "mdi-account-off",
                                          onClick: () => toggleChildDeactivation(user, true),
                                          variant: "danger",
                                        },
                                      ]),
                                  { label: "Delete", icon: "mdi-delete", onClick: () => { setContact(user); setDeleteModal(true); }, variant: "danger" },
                                  { label: "Complete programs", icon: "mdi-check", onClick: () => showConfirm({ title: "Complete programs", message: "You're about to complete all the programs that belong to this child. Do you want to proceed?", variant: "danger" }).then(async (ok) => { if (ok) { setActionLoadingId(user.id); try { await handleComplete(user.id); } finally { setActionLoadingId(null); } } }), variant: "primary" },
                                ]}
                              />
                            </td>
                            )}
                          </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    </div>
                  )}
                  {pagination.totalItems > 0 && (
                    <PaginationControls
                      currentPage={pagination.currentPage}
                      totalPages={pagination.totalPages}
                      totalItems={pagination.totalItems}
                      pageSize={pagination.itemsPerPage}
                      showAll={showAll}
                      handlePageChange={handlePageChange}
                      handlePageSizeChange={handlePageSizeChange}
                      goToNextPage={goToNextPage}
                      goToPreviousPage={goToPreviousPage}
                      canPreviousPage={pagination.hasPreviousPage}
                      canNextPage={pagination.hasNextPage}
                      paginatedDataLength={usersData.length}
                    />
                  )}
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>
                      {isEdit ? "Edit Child" : "Add New Child"}
                    </ModalHeader>
                    <ModalBody>
                      <Form onSubmit={validation.handleSubmit}>
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">First Name</Label>
                              <Input
                                name="firstName"
                                type="text"
                                placeholder="First Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.firstName || ""}
                                invalid={
                                  validation.touched.firstName &&
                                  validation.errors.firstName
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.errors.firstName}
                              </FormFeedback>
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Last Name</Label>
                              <Input
                                name="lastName"
                                type="text"
                                placeholder="Last Name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.lastName || ""}
                                invalid={
                                  validation.touched.lastName &&
                                  validation.errors.lastName
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.errors.lastName}
                              </FormFeedback>
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Age</Label>
                              <Input
                                name="age"
                                type="text"
                                placeholder="Age"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.age || ""}
                                invalid={
                                  validation.touched.age &&
                                  validation.errors.age
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.errors.age}
                              </FormFeedback>
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Gender</Label>
                              <Input
                                type="select"
                                name="gender"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.gender || ""}
                                invalid={
                                  validation.touched.gender &&
                                  validation.errors.gender
                                }
                              >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="other">Other</option>
                              </Input>
                              <FormFeedback type="invalid">
                                {validation.errors.gender}
                              </FormFeedback>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              {!isEdit ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary save-user"
                                >
                                  Create Child
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary save-user"
                                >
                                  Update Child
                                </button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withAuth(ManageChild);
